
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignComponentsThumbnail',
  components: { DesignContentLayout }
};
